import { render, staticRenderFns } from "./UploadedFilesEditModal.vue?vue&type=template&id=c9a376ec&scoped=true&"
import script from "./UploadedFilesEditModal.vue?vue&type=script&lang=ts&"
export * from "./UploadedFilesEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./UploadedFilesEditModal.vue?vue&type=style&index=0&id=c9a376ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a376ec",
  null
  
)

export default component.exports